//Styles ============================================
require('../css/app.scss');


//Scripts ===========================================
// require("jquery");
require('slick-carousel');
require('./script.js');
require('./select.js');



//////////////////
// WEBPACK FOOTER
// ./js/app.js
// module id = 1
// module chunks = 0